<template lang="pug">
    div(v-if="validComp" style="display: none;") New Heartbeat
</template>

<script lang="ts">
    import Vue from 'vue';
    import {
        SendHeartBeat,
        StopHeartBeat,
    } from '@/data';

    export default Vue.extend({
        data() {
            return {
                heartBeat: null,
                interval: null as any,
            }
        },
        methods: {
            clear() {
                if (!this.heartbeatInterval) {
                    return;
                }

                clearInterval(this.heartbeatInterval);
                this.heartbeatInterval = null;
            },
            send() {
                if (!this.validComp) {
                    return;
                }

                const options = {
                    heart_beatable_id: this.heartBeatableId,
                    heart_beatable_type: this.heartBeatableType,
                    source: this.source,
                }

                SendHeartBeat(options).then((response) => {
                    if (response.Data?.heart_beat?.id > 0) {
                        this.heartBeat = response.Data?.heart_beat;
                    } else {
                        this.stop();
                    }
                });
            },
            start() {
                // Send initial heartbeat
                this.send();

                console.log("intervalMsValue: ", this.intervalMsValue);
                
                // kick off continous heartbeat, clock job to cancel idles
                this.heartbeatInterval = setInterval(this.send, this.intervalMsValue);
            },
            stop() {
                this.clear();

                StopHeartBeat(this.heatBeatID).then((response) => {
                    this.heartBeat = null;
                });
            },
        },
        components: {
        },
        computed: {
            heatBeatID() {
                return this.heartBeat?.id || 0;
            },
            intervalMsValue() {
                return this.intervalMs > 0 ? this.intervalMs : 300000; // default to 5 minutes
            },
            validComp() {
                return this.heartBeatableId > 0 && this.heartBeatableType?.length > 0;
            },
            validHeartBeat() {
                return this.heatBeatID > 0;
            },
        },
        props: {
            heartBeatableId: Number,
            heartBeatableType: String,
            intervalMs: Number,
            source: String,
        },
        created() {
            this.start();
        },
        destroyed() {
            this.stop();
        },
    })
</script>